<header id="photos">
    <div class="header-info">
        <h1>{{hosting.name}}</h1>
        <div class="flex align-center">
            <div class="rate">
                <span class="material-symbols-outlined">star</span><span > {{hosting.review.average}}</span>
            </div>
            <div class="localizacion" href="#location">
                {{hosting.location.city}}, {{hosting.location.country}}
            </div>
        </div>
    </div>
    <div class="share-save">
        <span class="share"><span class="material-symbols-outlined">share</span>Share</span>
        <span class="save"><span class="material-symbols-outlined">favorite</span>Save</span>
    </div>
</header>